import React from 'react'
import { UserInactivity } from 'fmi-keepalive-client-components'
import redirect from '../../lib/redirect'
import env from '../../env'
import sessionStore from '../../stores/Session'

export function Inactivity ({ onSignOut, onSessionExpired, ...rest }) {
  const exp = sessionStore.getExpiration
  const sessionExpiredContent = () => (
    <div>
      <p>Your session has expired due to inactivity.</p>
      <p>You will be redirected to the Login page.</p>
    </div>
  )
  const handleSignout = async () => {
    await sessionStore.handleLogout()
    redirect.redirectToLogin()
    onSignOut()
  }
  const handleSessionExpired = () => {
    redirect.redirectToLogin()
    onSessionExpired()
  }
  const handleError = error => {
    console.log('error on inactivity handleError', error)
    if (error.response.status === 401) redirect.redirectToLogin()
  }

  return (
    <UserInactivity
      hostUrl={env.REACT_APP_EXTERNAL_URL}
      timeout={env.REACT_APP_KEEPALIVE_TIMEOUT}
      time={1000}
      onSignout={handleSignout}
      onSessionExpired={handleSessionExpired}
      onError={handleError}
      expireModalContent={sessionExpiredContent}
      tokenSessionData={{ exp }}
      {...rest}
    />
  )
}
